import Vue from "vue";
import App from "./App";
import router from "./router/router";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import AXIOS from "./config/http-common";
import CKEditor from "@ckeditor/ckeditor5-vue";
//Les 3 imports suivant sont pour vue-fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//CSS du toast
import "cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css";
//CSS du loader
import "vue-loading-overlay/dist/vue-loading.css";
//CSS global de l'appli
import "./assets/app.css";
//FontAwesome pour les icones, import tout d'un coup, possibilité de les importé un à un
import { fas } from "@fortawesome/free-solid-svg-icons";
//Layouts
import AppLayout from "./layouts/AppLayout.vue";
import LoginLayout from "./layouts/LoginLayout.vue";
import VeeValidate, { Validator } from "vee-validate";
import fr from "vee-validate/dist/locale/fr";

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

//Definition des layouts
Vue.component("app-layout", AppLayout);
Vue.component("login-layout", LoginLayout);

Vue.config.productionTip = false;

//Configuration de VeeValidate pour la validation des formulaires
Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: "veeFields",
  // This is not required but avoids possible naming conflicts
  errorBagName: "veeErrors",
});

Validator.localize("fr", fr);
//AXIO sera utilisable globalement en tant que propriété d'instance en utilisant this.$http ou Vue.prototype.$http
Vue.prototype.$http = AXIOS;

Vue.use(BootstrapVue);
Vue.use(CKEditor);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
